import { render } from "./SimInternationalPanel.vue?vue&type=template&id=3024cb5a&scoped=true"
import script from "./SimInternationalPanel.vue?vue&type=script&lang=js"
export * from "./SimInternationalPanel.vue?vue&type=script&lang=js"

import "./SimInternationalPanel.vue?vue&type=style&index=0&id=3024cb5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3024cb5a"]])

export default __exports__